export enum AttachmentErrors {
    FileTooBig = 'fileSizeOutOfRange'
}

export class Attachment {
    constructor(
        public id: number,
        public originalName?: string,
        public type?: string,
        public size?: number | string,
    ) {}

    static adapt(item: any): Attachment {
        return new Attachment(
            item.id,
            item.originalName,
            item.type,
            item.size,
        );
    }
}
